module.exports = __webpack_public_path__ + "img/case_8.b6f48ae5.png";